import * as React from 'react';
import {ReactNode} from 'react';
import {BlueLogoTextHeader} from 'components';

type Props = {children?: ReactNode; className?: string};

export const DirectBookingHeader = ({
  children,
  className = 'bg-white',
}: Props) => (
  <div
    className={`${className} px-2 pb-2 md:px-10 shadow-outline top-0 left-0 z-50`}
  >
    <div className="w-full px-2 pt-6 pb-5 flex">
      <BlueLogoTextHeader />
    </div>
    {children}
  </div>
);
